import { useTranslation } from 'react-i18next';
import { useGetWeighingNoteBillingStatus } from '@/clients/finance/useWeighingNoteBillingStatus';
import { GetWeighingNoteBillingStatusParams } from '@/clients/finance/types/WeighingNoteBilling';

type WeighingNoteBillingWarningProps = GetWeighingNoteBillingStatusParams;

export const WeighingNoteBillingWarning = ({
    weighingNoteNumber,
    netWeight,
    weightUnit,
    serviceDate,
    licensePlate,
}: WeighingNoteBillingWarningProps) => {
    const { t } = useTranslation();
    const { data } = useGetWeighingNoteBillingStatus({
        weighingNoteNumber,
        netWeight,
        weightUnit,
        serviceDate,
        licensePlate,
    });

    if (!data?.results?.length) return null;

    return (
        <>
            {data.results.map(result => (
                <span className="font-copy-sm text-critical px-2 pt-2">
                    {result.invoiceNumber
                        ? t('product.lineItemListing.weighingNote.alreadyBilled', {
                              invoiceNumber: result.invoiceNumber,
                              invoiceReceiver: result.invoiceReceiver ?? '',
                              transportPart: result.transportNumber ? `, transport ${result.transportNumber}` : '',
                          })
                        : t('product.lineItemListing.weighingNote.alreadyAssociated', {
                              reference: result.transportNumber ?? result.orderNumber ?? '',
                              invoiceReceiver: result.invoiceReceiver ?? '',
                          })}
                </span>
            ))}
        </>
    );
};
